import styled, { css } from 'styled-components';

export const CheckboxContainer = styled.div`
  cursor: pointer;
  width: 18px;
  height: 18px;
  flex: 0 0 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-size: 100%;
  border: solid 1px ${({ theme }) => theme.commons.checkBox.borderColor};
  border-radius: 2px;
  ${({ selected, theme }) =>
    selected &&
    css`
      background: ${theme.commons.checkBox.selectedColor};
      background-size: 100%;
      color: white;
    `};
`;
